export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  REFUND: '/refund',
  PROFILE: '/profile',
  COURSES: '/courses',
  FAVORITES: '/favorites',
  SUBSCRIBE: '/subscribe',
  WC: '/wc',
  WEDDING_COURSE_V2: '/weddingcourse',
  CARD: (cardId: string | number = ':cardId') => `/card/${cardId}`,
  COURSE_DETAIL: (courseId: string | number = ':courseId') => `/courses/${courseId}`,
  LESSON: (courseId: string | number = ':courseId', lessonId: string | number = ':lessonId') =>
    `/courses/${courseId}/lesson/${lessonId}`,
  CALCULATOR: (cardId: string | number = ':cardId?') => `/calculator/${cardId}`,
  LINK_TELEGRAM_CONFIRM: '/link-telegram/confirm',
  TELEGRAM_AUTH_CONFIRM: '/telegram-auth/confirm'
} as const

// Свадебный курс — единственный курс с grant_type='buy', публикуется по короткой ссылке /wc.
export const WEDDING_COURSE_ID = 1

// Оплата свадебного курса временно идёт через отдельного Telegram-бота
// (не через web-флоу). Та же ссылка использовалась до перехода на оплату картой.
export const WEDDING_BOT_PAYMENT_URL =
  'https://telegram.me/pauline_wedding_bot?start=link_a1vInKgosx'
